import { AfterViewInit, Component, inject, OnInit, signal, ViewChild } from '@angular/core';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { SnackbarService } from '../../../../shared/services/snackbar/snackbar.service';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { MdrtStatus } from '../../dashboard-interfaces/mdrt-status.interface';
import { MdrtStatusByAdvisors } from '../../dashboard-interfaces/mdrt-status-by-advisors.interface';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { DashboardMdrtStatusService } from '../../dashboard-services/dashboard-mdrt-status/dashboard-mdrt-status.service';
import { HttpStatusCode } from 'axios';
import { ElementRef } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'dashboard-mdrt-status',
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatDividerModule
  ],
  templateUrl: './mdrt-status.component.html',
  styleUrl: './mdrt-status.component.scss'
})
export class MdrtStatusComponent implements OnInit, AfterViewInit {

  private router = inject(Router);
  private sessionStorageService = inject(SessionStorageService);
  private snackbarServices = inject(SnackbarService);
  private dashboardMdrtStatusService = inject(DashboardMdrtStatusService);

  private currentUserRole: string = "";
  protected mdrtStatusIncomeCount: { mdrt: number, cot: number, tot: number } = {
    mdrt: 0,
    cot: 0,
    tot: 0
  };

  protected mdrtStatusCommissionCount: { mdrt: number, cot: number, tot: number } = {
    mdrt: 0,
    cot: 0,
    tot: 0
  };

  protected mdrtStatusPremiumCount: { mdrt: number, cot: number, tot: number } = {
    mdrt: 0,
    cot: 0,
    tot: 0
  };

  isMdrtStatusDashboardHidden = signal(false);
  isMdrtStatusFilterAndPaginatorHidden = signal(false);

  protected mdrtStatusIncomeData: MdrtStatusByAdvisors[] = [];
  protected mdrtStatusIncomeTableDisplayFirstColumn: string[] = [];
  protected mdrtStatusIncomeTableDisplaySecondColumn: string[] = ["cotQualification", "cotTarget", "cotAchievedGr", "cotShortfall", "cotMetOrNotmet"];
  protected mdrtStatusIncomeTableDisplayThirdColumn: string[] = ["totQualification", "totTarget", "totAchievedGr", "totShortfall", "totMetOrNotmet"];
  protected mdrtStatusIncomeTableDataSource = new MatTableDataSource<MdrtStatusByAdvisors>();

  protected mdrtStatusCommissionData: MdrtStatusByAdvisors[] = [];
  protected mdrtStatusCommissionTableDisplayFirstColumn: string[] = [];
  protected mdrtStatusCommissionTableDisplaySecondColumn: string[] = ["cotQualification", "cotTarget", "cotAchievedGr", "cotShortfall", "cotMetOrNotmet"];
  protected mdrtStatusCommissionTableDisplayThirdColumn: string[] = ["totQualification", "totTarget", "totAchievedGr", "totShortfall", "totMetOrNotmet"];
  protected mdrtStatusCommissionTableDataSource = new MatTableDataSource<MdrtStatusByAdvisors>();

  protected mdrtStatusPremiumData: MdrtStatusByAdvisors[] = [];
  protected mdrtStatusPremiumTableDisplayFirstColumn: string[] = [];
  protected mdrtStatusPremiumTableDisplaySecondColumn: string[] = ["cotQualification", "cotTarget", "cotAchievedGr", "cotShortfall", "cotMetOrNotmet"];
  protected mdrtStatusPremiumTableDisplayThirdColumn: string[] = ["totQualification", "totTarget", "totAchievedGr", "totShortfall", "totMetOrNotmet"];
  protected mdrtStatusPremiumTableDataSource = new MatTableDataSource<MdrtStatusByAdvisors>();

  mdrtStatusIncomeTableFilterFc = new FormControl("");
  mdrtStatusCommissionTableFilterFc = new FormControl("");
  mdrtStatusPremiumTableFilterFc = new FormControl("");

  @ViewChild('mdrtStatusIncomeTablePaginator')
  mdrtStatusIncomeTablePaginator!: MatPaginator;
  @ViewChild('mdrtStatusIncomeTableSort')
  mdrtStatusIncomeTableSort = new MatSort();
  @ViewChild('mdrtStatusCommissionTablePaginator')
  mdrtStatusCommissionTablePaginator!: MatPaginator;
  @ViewChild('mdrtStatusCommissionTableSort')
  mdrtStatusCommissionTableSort = new MatSort();
  @ViewChild('mdrtStatusPremiumTablePaginator')
  mdrtStatusPremiumTablePaginator!: MatPaginator;
  @ViewChild('mdrtStatusPremiumTableSort')
  mdrtStatusPremiumTableSort = new MatSort();
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;
  @ViewChild('commissionSearchInput')
  commissionSearchInput!: ElementRef<HTMLInputElement>;
  @ViewChild('premiumSearchInput')
  premiumSearchInput!: ElementRef<HTMLInputElement>;

  constructor() { }

  async ngOnInit(): Promise<void> {

    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();

    if (['Corporate', 'BDM'].includes(this.currentUserRole)) {
      this.mdrtStatusIncomeTableDisplayFirstColumn = ["repCode", "personName", "branch", "mdrtQualification", "mdrtTarget", "mdrtAchievedGr", "mdrtShortfall", "mdrtMetOrNotmet"];
      this.mdrtStatusCommissionTableDisplayFirstColumn = ["repCode", "personName", "branch", "mdrtQualification", "mdrtTarget", "mdrtAchievedGr", "mdrtShortfall", "mdrtMetOrNotmet"];
      this.mdrtStatusPremiumTableDisplayFirstColumn = ["repCode", "personName", "branch", "mdrtQualification", "mdrtTarget", "mdrtAchievedGr", "mdrtShortfall", "mdrtMetOrNotmet"];
    }
    else {
      this.mdrtStatusIncomeTableDisplayFirstColumn = ["repCode", "personName", "mdrtQualification", "mdrtTarget", "mdrtAchievedGr", "mdrtShortfall", "mdrtMetOrNotmet"];
      this.mdrtStatusCommissionTableDisplayFirstColumn = ["repCode", "personName", "mdrtQualification", "mdrtTarget", "mdrtAchievedGr", "mdrtShortfall", "mdrtMetOrNotmet"];
      this.mdrtStatusPremiumTableDisplayFirstColumn = ["repCode", "personName", "mdrtQualification", "mdrtTarget", "mdrtAchievedGr", "mdrtShortfall", "mdrtMetOrNotmet"];
    }

    await this.getMdrtStatus();

    this.mdrtStatusIncomeTableDataSource.data = this.mdrtStatusIncomeData;
    this.mdrtStatusCommissionTableDataSource.data = this.mdrtStatusCommissionData;
    this.mdrtStatusPremiumTableDataSource.data = this.mdrtStatusPremiumData;

    if (['Advisor'].includes(this.currentUserRole)) {
      this.isMdrtStatusDashboardHidden.set(true);
      this.isMdrtStatusFilterAndPaginatorHidden.set(true);
    }
  }


  ngAfterViewInit(): void {
    this.mdrtStatusIncomeTableDataSource.paginator = this.mdrtStatusIncomeTablePaginator;
    this.mdrtStatusIncomeTableDataSource.sort = this.mdrtStatusIncomeTableSort;

    this.mdrtStatusCommissionTableDataSource.paginator = this.mdrtStatusCommissionTablePaginator;
    this.mdrtStatusCommissionTableDataSource.sort = this.mdrtStatusCommissionTableSort;

    this.mdrtStatusPremiumTableDataSource.paginator = this.mdrtStatusPremiumTablePaginator;
    this.mdrtStatusPremiumTableDataSource.sort = this.mdrtStatusPremiumTableSort;
  }

  async getMdrtStatus() {
    const responseData = await this.dashboardMdrtStatusService
      .getDashboardMdrtStatus()
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        console.error(error);
        return error;
      });

    if (responseData.status === HttpStatusCode.Ok) {
      // Manager, Director : apedata, apesummary
      // Agent : apesummary
      // Corporate : branchdata, corporateapedata
      // BDM : bdmapedata, bdmbranchreporting
      if (this.currentUserRole === 'Corporate') {
        this.mapMdrtStatusData(responseData.data.responsedata.corporateapedata, responseData.data.responsedata.projectconfiguration);
      }
      else if (this.currentUserRole === 'BDM') {
        this.mapMdrtStatusData(responseData.data.responsedata.bdmapedata, responseData.data.responsedata.projectconfiguration);
      }
      else if (['Manager', 'Director'].includes(this.currentUserRole)) {
        this.mapMdrtStatusData(responseData.data.responsedata.apedata, responseData.data.responsedata.projectconfiguration);
      }
      else {
        this.mapMdrtStatusData(responseData.data.responsedata.apedata, responseData.data.responsedata.projectconfiguration);
      }
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackbarServices.openFailureSnackBar("Something went wrong!!!");
      }
      if(responseData.code === HttpStatusCode.Unauthorized) {
        this.snackbarServices.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  protected mapMdrtStatusData(mdrtStatusList: any[], projConfig: any[]) {
    const incomeMdrtTarget: string = projConfig.filter(pcItem => pcItem.pjConfName === "Income_MDRT")[0].pjConfValue;
    const incomeCotTarget: string = projConfig.filter(pcItem => pcItem.pjConfName === "Income_COT")[0].pjConfValue;
    const incomeTotTarget: string = projConfig.filter(pcItem => pcItem.pjConfName === "Income_TOT")[0].pjConfValue;
    const commissionMdrtTarget: string = projConfig.filter(pcItem => pcItem.pjConfName === "Commision_MDRT")[0].pjConfValue;
    const commissionCotTarget: string = projConfig.filter(pcItem => pcItem.pjConfName === "Commision_COT")[0].pjConfValue;
    const commissionTotTarget: string = projConfig.filter(pcItem => pcItem.pjConfName === "Commision_TOT")[0].pjConfValue;
    const premiumMdrtTarget: string = projConfig.filter(pcItem => pcItem.pjConfName === "Prenium_MDRT")[0].pjConfValue;
    const premiumCotTarget: string = projConfig.filter(pcItem => pcItem.pjConfName === "Prenium_COT")[0].pjConfValue;
    const premiumTotTarget: string = projConfig.filter(pcItem => pcItem.pjConfName === "Prenium_TOT")[0].pjConfValue;

    mdrtStatusList.forEach((mdrtStatusItem: any) => {
      // Income Method
      let mdrtStatusIncome: MdrtStatusByAdvisors = {
        repCode: mdrtStatusItem.piasRepCode,
        personName: mdrtStatusItem.agentRealName,
        branch: mdrtStatusItem.branch,
        mdrtQualification: "MDRT",
        mdrtTarget: incomeMdrtTarget,
        mdrtAchievedGr: mdrtStatusItem.mdrtIncomeMethodAchivedGr.toString(),
        mdrtShortfall: "0",
        cotQualification: "COT",
        cotTarget: incomeCotTarget,
        cotAchievedGr: mdrtStatusItem.mdrtIncomeMethodAchivedGr.toString(),
        cotShortfall: "0",
        totQualification: "TOT",
        totTarget: incomeTotTarget,
        totAchievedGr: mdrtStatusItem.mdrtIncomeMethodAchivedGr.toString(),
        totShortfall: "0"
      };

      let incomeMdrtShortfall: number = 0;
      let incomeCotShortfall: number = 0;
      let incomeTotShortfall: number = 0;

      if (Number.parseInt(mdrtStatusItem.mdrtIncomeMethodAchivedGr)) {
        if (Number.parseInt(mdrtStatusItem.mdrtIncomeMethodAchivedGr) < Number.parseInt(incomeMdrtTarget)) {
          incomeMdrtShortfall = Number.parseInt(incomeMdrtTarget) - Number.parseInt(mdrtStatusItem.mdrtIncomeMethodAchivedGr);
        } else {
          incomeMdrtShortfall = 0;
          this.mdrtStatusIncomeCount.mdrt = this.mdrtStatusIncomeCount.mdrt + 1;
        }

        if (Number.parseInt(mdrtStatusItem.mdrtIncomeMethodAchivedGr) < Number.parseInt(incomeCotTarget)) {
          incomeCotShortfall = Number.parseInt(incomeCotTarget) - Number.parseInt(mdrtStatusItem.mdrtIncomeMethodAchivedGr);
        } else {
          incomeCotShortfall = 0;
          this.mdrtStatusIncomeCount.cot = this.mdrtStatusIncomeCount.cot + 1;
        }

        if (Number.parseInt(mdrtStatusItem.mdrtIncomeMethodAchivedGr) < Number.parseInt(incomeTotTarget)) {
          incomeTotShortfall = Number.parseInt(incomeTotTarget) - Number.parseInt(mdrtStatusItem.mdrtIncomeMethodAchivedGr);
        } else {
          incomeTotShortfall = 0;
          this.mdrtStatusIncomeCount.tot = this.mdrtStatusIncomeCount.tot + 1;
        }
      } else {
        incomeMdrtShortfall = Number.parseInt(incomeMdrtTarget);
        incomeCotShortfall = Number.parseInt(incomeCotTarget);
        incomeTotShortfall = Number.parseInt(incomeTotTarget);
      }

      mdrtStatusIncome.mdrtShortfall = incomeMdrtShortfall.toString();
      mdrtStatusIncome.cotShortfall = incomeCotShortfall.toString();
      mdrtStatusIncome.totShortfall = incomeTotShortfall.toString();
      this.mdrtStatusIncomeData.push(mdrtStatusIncome);

      // Commission Method
      let mdrtStatusCommission: MdrtStatusByAdvisors = {
        repCode: mdrtStatusItem.piasRepCode,
        personName: mdrtStatusItem.agentRealName,
        branch: mdrtStatusItem.branch,
        mdrtQualification: "MDRT",
        mdrtTarget: commissionMdrtTarget,
        mdrtAchievedGr: mdrtStatusItem.mdrtCommisionMethodAchivedGr.toString(),
        mdrtShortfall: "0",
        cotQualification: "COT",
        cotTarget: commissionCotTarget,
        cotAchievedGr: mdrtStatusItem.mdrtCommisionMethodAchivedGr.toString(),
        cotShortfall: "0",
        totQualification: "TOT",
        totTarget: commissionTotTarget,
        totAchievedGr: mdrtStatusItem.mdrtCommisionMethodAchivedGr.toString(),
        totShortfall: "0"
      };

      let commissionMdrtShortfall: number = 0;
      let commissionCotShortfall: number = 0;
      let commissionTotShortfall: number = 0;

      if (Number.parseInt(mdrtStatusItem.mdrtCommisionMethodAchivedGr)) {
        if (Number.parseInt(mdrtStatusItem.mdrtCommisionMethodAchivedGr) < Number.parseInt(commissionMdrtTarget)) {
          commissionMdrtShortfall = Number.parseInt(commissionMdrtTarget) - Number.parseInt(mdrtStatusItem.mdrtCommisionMethodAchivedGr);
        } else {
          commissionMdrtShortfall = 0;
          this.mdrtStatusCommissionCount.mdrt = this.mdrtStatusCommissionCount.mdrt + 1;
        }

        if (Number.parseInt(mdrtStatusItem.mdrtCommisionMethodAchivedGr) < Number.parseInt(commissionCotTarget)) {
          commissionCotShortfall = Number.parseInt(commissionCotTarget) - Number.parseInt(mdrtStatusItem.mdrtCommisionMethodAchivedGr);
        } else {
          commissionCotShortfall = 0;
          this.mdrtStatusCommissionCount.cot = this.mdrtStatusCommissionCount.cot + 1;
        }

        if (Number.parseInt(mdrtStatusItem.mdrtCommisionMethodAchivedGr) < Number.parseInt(commissionTotTarget)) {
          commissionTotShortfall = Number.parseInt(commissionTotTarget) - Number.parseInt(mdrtStatusItem.mdrtCommisionMethodAchivedGr);
        } else {
          commissionTotShortfall = 0;
          this.mdrtStatusCommissionCount.tot = this.mdrtStatusCommissionCount.tot + 1;
        }
      } else {
        commissionMdrtShortfall = Number.parseInt(commissionMdrtTarget);
        commissionCotShortfall = Number.parseInt(commissionCotTarget);
        commissionTotShortfall = Number.parseInt(commissionTotTarget);
      }

      mdrtStatusCommission.mdrtShortfall = commissionMdrtShortfall.toString();
      mdrtStatusCommission.cotShortfall = commissionCotShortfall.toString();
      mdrtStatusCommission.totShortfall = commissionTotShortfall.toString();
      this.mdrtStatusCommissionData.push(mdrtStatusCommission);

      // Premium Method
      let mdrtStatusPremium: MdrtStatusByAdvisors = {
        repCode: mdrtStatusItem.piasRepCode,
        personName: mdrtStatusItem.agentRealName,
        branch: mdrtStatusItem.branch,
        mdrtQualification: "MDRT",
        mdrtTarget: premiumMdrtTarget,
        mdrtAchievedGr: mdrtStatusItem.mdrtPermiumMethodAchivedGr,
        mdrtShortfall: "0",
        cotQualification: "COT",
        cotTarget: premiumCotTarget,
        cotAchievedGr: mdrtStatusItem.mdrtPermiumMethodAchivedGr,
        cotShortfall: "0",
        totQualification: "TOT",
        totTarget: premiumTotTarget,
        totAchievedGr: mdrtStatusItem.mdrtPermiumMethodAchivedGr,
        totShortfall: "0"
      };

      let premiumMdrtShortfall: number = 0;
      let premiumCotShortfall: number = 0;
      let premiumTotShortfall: number = 0;

      if (Number.parseInt(mdrtStatusItem.mdrtPermiumMethodAchivedGr)) {
        if (Number.parseInt(mdrtStatusItem.mdrtPermiumMethodAchivedGr) < Number.parseInt(premiumMdrtTarget)) {
          premiumMdrtShortfall = Number.parseInt(premiumMdrtTarget) - Number.parseInt(mdrtStatusItem.mdrtPermiumMethodAchivedGr);
        } else {
          premiumMdrtShortfall = 0;
          this.mdrtStatusPremiumCount.mdrt = this.mdrtStatusPremiumCount.mdrt + 1;
        }

        if (Number.parseInt(mdrtStatusItem.mdrtPermiumMethodAchivedGr) < Number.parseInt(premiumCotTarget)) {
          premiumCotShortfall = Number.parseInt(premiumCotTarget) - Number.parseInt(mdrtStatusItem.mdrtPermiumMethodAchivedGr);
        } else {
          premiumCotShortfall = 0;
          this.mdrtStatusPremiumCount.cot = this.mdrtStatusPremiumCount.cot + 1;
        }

        if (Number.parseInt(mdrtStatusItem.mdrtPermiumMethodAchivedGr) < Number.parseInt(premiumTotTarget)) {
          premiumTotShortfall = Number.parseInt(premiumTotTarget) - Number.parseInt(mdrtStatusItem.mdrtPermiumMethodAchivedGr);
        } else {
          premiumTotShortfall = 0;
          this.mdrtStatusPremiumCount.tot = this.mdrtStatusPremiumCount.tot + 1;
        }
      } else {
        premiumMdrtShortfall = Number.parseInt(premiumMdrtTarget);
        premiumCotShortfall = Number.parseInt(premiumCotTarget);
        premiumTotShortfall = Number.parseInt(premiumTotTarget);
      }

      mdrtStatusPremium.mdrtShortfall = premiumMdrtShortfall.toString();
      mdrtStatusPremium.cotShortfall = premiumCotShortfall.toString();
      mdrtStatusPremium.totShortfall = premiumTotShortfall.toString();
      this.mdrtStatusPremiumData.push(mdrtStatusPremium);
    });

    this.mdrtStatusIncomeData.sort((item1, item2) => Number.parseInt(item2.mdrtAchievedGr) - Number.parseInt(item1.mdrtAchievedGr));
    this.mdrtStatusCommissionData.sort((item1, item2) => Number.parseInt(item2.mdrtAchievedGr) - Number.parseInt(item1.mdrtAchievedGr));
    this.mdrtStatusPremiumData.sort((item1, item2) => Number.parseInt(item2.mdrtAchievedGr) - Number.parseInt(item1.mdrtAchievedGr));

  }

  protected __applyIncomeMethodDataFilter() {
    let filterValue: string = this.mdrtStatusIncomeTableFilterFc.value?.toString() || '';

    let tempMrdtStatusIncomeMethodByAdvisorTableData: MdrtStatusByAdvisors[] = [];

    if (filterValue) {
      if (['Corporate', 'BDM'].includes(this.currentUserRole)) {
        tempMrdtStatusIncomeMethodByAdvisorTableData = this.mdrtStatusIncomeData.filter(mdrtData =>
          mdrtData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || mdrtData.personName.toLowerCase().includes(filterValue.toLowerCase())
          || mdrtData.branch.toLowerCase().includes(filterValue.toLowerCase())
        );
      } else {
        tempMrdtStatusIncomeMethodByAdvisorTableData = this.mdrtStatusIncomeData.filter(mdrtData =>
          mdrtData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || mdrtData.personName.toLowerCase().includes(filterValue.toLowerCase())
        );
      }
    } else {
      tempMrdtStatusIncomeMethodByAdvisorTableData = this.mdrtStatusIncomeData;
    }

    this.mdrtStatusIncomeTableDataSource.data = tempMrdtStatusIncomeMethodByAdvisorTableData;
  }

  protected __applyCommissionMethodDataFilter() {
    let filterValue: string = this.mdrtStatusCommissionTableFilterFc.value?.toString() || '';

    let tempMrdtStatusCommissionMethodByAdvisorTableData: MdrtStatusByAdvisors[] = [];

    if (filterValue) {
      if (['Corporate', 'BDM'].includes(this.currentUserRole)) {
        tempMrdtStatusCommissionMethodByAdvisorTableData = this.mdrtStatusCommissionData.filter(mdrtData =>
          mdrtData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || mdrtData.personName.toLowerCase().includes(filterValue.toLowerCase())
          || mdrtData.branch.toLowerCase().includes(filterValue.toLowerCase())
        );
      } else {
        tempMrdtStatusCommissionMethodByAdvisorTableData = this.mdrtStatusCommissionData.filter(mdrtData =>
          mdrtData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || mdrtData.personName.toLowerCase().includes(filterValue.toLowerCase())
        );
      }
    } else {
      tempMrdtStatusCommissionMethodByAdvisorTableData = this.mdrtStatusCommissionData;
    }

    this.mdrtStatusCommissionTableDataSource.data = tempMrdtStatusCommissionMethodByAdvisorTableData;
  }

  protected __applyPremiumMethodDataFilter() {
    let filterValue: string = this.mdrtStatusPremiumTableFilterFc.value?.toString() || '';

    let tempMrdtStatusPremiumMethodByAdvisorTableData: MdrtStatusByAdvisors[] = [];

    if (filterValue) {
      if (['Corporate', 'BDM'].includes(this.currentUserRole)) {
        tempMrdtStatusPremiumMethodByAdvisorTableData = this.mdrtStatusPremiumData.filter(mdrtData =>
          mdrtData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || mdrtData.personName.toLowerCase().includes(filterValue.toLowerCase())
          || mdrtData.branch.toLowerCase().includes(filterValue.toLowerCase())
        );
      } else {
        tempMrdtStatusPremiumMethodByAdvisorTableData = this.mdrtStatusPremiumData.filter(mdrtData =>
          mdrtData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || mdrtData.personName.toLowerCase().includes(filterValue.toLowerCase())
        );
      }
    } else {
      tempMrdtStatusPremiumMethodByAdvisorTableData = this.mdrtStatusPremiumData;
    }

    this.mdrtStatusPremiumTableDataSource.data = tempMrdtStatusPremiumMethodByAdvisorTableData;
  }
  clearSearch(): void {
    this.mdrtStatusIncomeTableFilterFc.setValue('');
    this.__applyIncomeMethodDataFilter();
    this.searchInput.nativeElement.focus();
  }
  clearCommissionSearch(): void {
    this.mdrtStatusCommissionTableFilterFc.setValue('');
    this.__applyCommissionMethodDataFilter();
    this.commissionSearchInput.nativeElement.focus();
  }
  clearPremiumSearch(): void {
    this.mdrtStatusPremiumTableFilterFc.setValue('');
    this.__applyPremiumMethodDataFilter();
    this.premiumSearchInput.nativeElement.focus();
  }




}
